import { createFileRoute } from '@tanstack/react-router'

import { ListingScreen } from '@/features/market/listing-screen'

/** One listing: what it is, its sightings, and where the platform saw it. */
export const Route = createFileRoute('/_app/platform/market/$listingId')({
  component: ListingScreen,
})
